import { FontWeight, ITheme } from '@quicktools/shared-components/styles';
import { createUseStyles } from 'react-jss';

const useStyles = createUseStyles(
  ({ colors }: ITheme) => ({
    inputClassName: {
      resize: 'none',
      overflowY: 'auto',
      overflowX: 'hidden',
      width: '100%',
      borderRadius: 8,
      fontSize: '14px',
      lineHeight: '20px',
      fontWeight: FontWeight.SemiBold,
      color: colors.black,
      outline: 'none',

      // always show scrollbars
      '&::-webkit-scrollbar': {
        '-webkit-appearance': 'none',
        width: 4,
      },

      '&::-webkit-scrollbar-thumb': {
        borderRadius: 4,
        backgroundColor: 'rgba(0,0,0,.25)',
        '-webkit-box-shadow': '0 0 1px rgba(255,255,255,.5)',
      },

      '& h1': {
        lineHeight: '120%',
        marginBottom: 12,
      },
      '& h2': {
        lineHeight: '130%',
        marginBottom: 10,
      },
      '& h3': {
        lineHeight: '140%',
        marginBottom: 10,
      },
      '& h5': {
        lineHeight: '140%',
        marginBottom: 10,
      },
      '& p': {
        marginBottom: 16,
      },
      '& .br': {
        display: 'block',
        marginBottom: 16,
      },
      '& hr': {
        marginBottom: 16,
      },
      '& ul': {
        listStyleType: 'disc',
        marginLeft: 16,
        marginBottom: 16,
      },
      '& ol': {
        marginLeft: 20,
        marginBottom: 16,
      },
      '& li': {
        marginBottom: 8,
      },
      '& :last-child': {
        marginBottom: 0,
      },
      '&:-webkit-autofill, &:-webkit-autofill:hover, &:-webkit-autofill:active,&:-webkit-autofill:focus':
        {
          boxShadow: `0 0 0 1000px white inset !important`,
        },
    },
    maxHeight: {
      maxHeight: 256,
      overflowY: 'auto',
    },
  }),
  { name: 'ResultTextInputArea' },
);
export default useStyles;
